export enum AppLanguage {
  pl = 'pl',
  en = 'en',
  de = 'de',
  cs = 'cs',
  fr = 'fr'
}
